import {FC} from 'react'
import {Navigate} from 'react-router-dom'
import LossOfOpportunityListPage from '../../modules/loss-of-opportunity/LossOfOpportunityListPage'
import SharedData from '../../modules/common/SharedData'
import {isShopUser} from '../../modules/common/stockScope'

const LossOfOpportunityPage: FC = () => {
    const {currentUser} = SharedData()

    // A partner shop has no such report (owner ask 2026-11-03): its menus do not offer it, and a
    // typed or old link lands on the dashboard rather than an empty table.
    if (isShopUser(currentUser)) {
        return <Navigate to='/dashboard' replace/>
    }

    return (
        <>
            <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
                <div className='col-md-12 col-lg-12 mb-md-5 mb-xl-10'>
                    <LossOfOpportunityListPage/>
                </div>
            </div>
        </>
    )
}

export default LossOfOpportunityPage